"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TupleElementDefinition = exports.TupleElement = exports.Tuple = exports.Property = void 0;
var expression_1 = require("./expression");
var builder_1 = require("./builder");
var Property = /** @class */ (function (_super) {
    __extends(Property, _super);
    function Property(json) {
        var _this = _super.call(this, json) || this;
        _this.scope = json.scope;
        _this.source = (0, builder_1.build)(json.source);
        _this.path = json.path;
        return _this;
    }
    Property.prototype.exec = function (ctx) {
        var obj = this.scope != null ? ctx.get(this.scope) : this.source;
        if (obj instanceof expression_1.Expression) {
            obj = obj.execute(ctx);
        }
        var val = getPropertyFromObject(obj, this.path);
        if (val == null) {
            var parts = this.path.split('.');
            var curr_obj = obj;
            for (var _i = 0, parts_1 = parts; _i < parts_1.length; _i++) {
                var part = parts_1[_i];
                var _obj = getPropertyFromObject(curr_obj, part);
                curr_obj = _obj instanceof Function ? _obj.call(curr_obj) : _obj;
            }
            val = curr_obj != null ? curr_obj : null; // convert undefined to null
        }
        if (val instanceof Function) {
            return val.call(obj);
        }
        else {
            return val;
        }
    };
    return Property;
}(expression_1.Expression));
exports.Property = Property;
function getPropertyFromObject(obj, path) {
    var val;
    if (obj != null) {
        val = obj[path];
        if (val === undefined && typeof obj.get === 'function') {
            val = obj.get(path);
        }
    }
    return val;
}
var Tuple = /** @class */ (function (_super) {
    __extends(Tuple, _super);
    function Tuple(json) {
        var _this = _super.call(this, json) || this;
        var elements = json.element != null ? json.element : [];
        _this.elements = elements.map(function (el) {
            return {
                name: el.name,
                value: (0, builder_1.build)(el.value)
            };
        });
        return _this;
    }
    Object.defineProperty(Tuple.prototype, "isTuple", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Tuple.prototype.exec = function (ctx) {
        var val = {};
        for (var _i = 0, _a = this.elements; _i < _a.length; _i++) {
            var el = _a[_i];
            val[el.name] = el.value != null ? el.value.execute(ctx) : undefined;
        }
        return val;
    };
    return Tuple;
}(expression_1.Expression));
exports.Tuple = Tuple;
var TupleElement = /** @class */ (function (_super) {
    __extends(TupleElement, _super);
    function TupleElement() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TupleElement;
}(expression_1.UnimplementedExpression));
exports.TupleElement = TupleElement;
var TupleElementDefinition = /** @class */ (function (_super) {
    __extends(TupleElementDefinition, _super);
    function TupleElementDefinition() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TupleElementDefinition;
}(expression_1.UnimplementedExpression));
exports.TupleElementDefinition = TupleElementDefinition;
//# sourceMappingURL=structured.js.map